export const CameraGridSkeleton = () => (
  <div className="w-full h-[600px] bg-gray-100 rounded-lg p-4 animate-pulse">
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 h-full">
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="bg-gray-300 rounded-lg flex items-center justify-center"
        >
          <div className="text-center">
            <div className="w-8 h-8 mx-auto mb-2 bg-gray-400 rounded-full"></div>
            <p className="text-gray-500 text-sm">Loading Camera {i + 1}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);
